import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  SelectChangeEvent,
  SxProps,
  Theme,
} from "@mui/material";

export type SelectInputOptions = {
  label: React.ReactNode;
  value: string | number | readonly string[] | undefined;
};

export type SelectInuputComponentProps = {
  title?: string;
  options: SelectInputOptions[];
  setFilter: (filter: any) => void;
  ContainerSx?: SxProps<Theme>;
  defaultValue?: string | number | readonly string[] | undefined;
  fullWidth?: boolean;
  sx?: SxProps<Theme>;
};

export default function SelectInuputComponent(
  props: SelectInuputComponentProps
) {
  const { options, setFilter, title, ContainerSx, defaultValue, sx } = props;
  const handleChange = (event: SelectChangeEvent) => {
    setFilter(event.target.value as string);
  };

  return (
    <FormControl sx={{ marginTop: "5px", ...ContainerSx }} fullWidth={props.fullWidth ?? true}>
      {title &&
        <InputLabel id="demo-simple-select-label">{title}</InputLabel>
      }
      <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        onChange={handleChange}
        defaultValue={`${defaultValue}`}
        sx={sx}
      >
        {options.map((item) => (
          <MenuItem value={item.value}>{item.label}</MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
